module.exports = __webpack_public_path__ + "img/message.f91f6c85.svg";